import { Pipe, PipeTransform } from '@angular/core';
import { ConfigProvider } from '../../providers/config/config';
/**
 * Generated class for the NomenclaturaPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'nomenclatura',
})
export class NomenclaturaPipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  constructor(public configProvider: ConfigProvider) {}

  capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  transform(value: string, toUpper: string) {
    return this.configProvider.getNomenclatura(value).then((h) => {
      if (toUpper == 'true') {
        return h;
      } else {
        return h;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/pipes/nomenclatura/nomenclatura.ts